import Reveal from '@/pages/zz-review/components/Reveal';

export default function RgHero() {
  return (
    <section className="relative w-full pt-28 md:pt-36 pb-16 md:pb-24 bg-background-50 overflow-hidden">
      <img src="/images/trilogy/rg-tree.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-50/60 via-background-50 to-background-50 pointer-events-none" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          <Reveal>
            <div className="flex justify-center lg:justify-end">
              <div className="w-60 md:w-80 rounded-lg overflow-hidden border border-background-200/70 bg-background-950">
                <div className="relative w-full aspect-[2/3]">
                  <img
                    src="https://static.readdy.ai/image/411a6cec9481afaab6fb82dad412c4e6/43da542daffaa8061926fcf4d574bdfc.jpeg"
                    alt="《1001旋轉門》正式書封"
                    title="《1001旋轉門》生命實踐著作"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={80}>
            <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-primary-800 mb-4">
              AUM1001 MATRIX｜START HERE
            </p>
            <h1
              className="text-4xl md:text-5xl lg:text-6xl leading-tight text-foreground-900 mb-3"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              1001 旋轉門
            </h1>
            <p className="text-sm md:text-base tracking-[0.15em] uppercase text-foreground-400 mb-3">
              1001 Revolving Gate
            </p>
            <p
              className="text-lg md:text-xl text-foreground-700 mb-3"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              智人如何入世成功揚升5D
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              一本陪伴智人在真實生活中回歸並守住中軸、整合 1D–5D 生命能力，以一年築基走向入世成功，使生命更能成為真實自己的實踐書。
            </p>

            <div className="inline-flex items-start gap-1.5 text-xs text-primary-800 bg-primary-100 border border-primary-200/70 rounded-2xl px-3 py-2 mb-7 leading-relaxed">
              <i className="ri-calendar-line mt-0.5 shrink-0" />
              嘖嘖募資專案審核中，正式上線日期將於審核通過後公告。
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#story"
                className="whitespace-nowrap px-8 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base hover:bg-primary-600 transition-colors cursor-pointer text-center"
              >
                了解出版計畫
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
